export const products = {
  'fontes-business-one': {
    slug: 'fontes-business-one',
    name: 'Fontes Business One',
    shortName: 'One',
    badge: 'ERP Completo • Web & Mobile',
    headline: 'ERP completo para empresas que precisam de',
    highlight: 'controle total',
    description:
      'O Fontes Business One é um ERP+CRM multiempresa modular: clientes, contratos com assinatura digital, marketplace de complementos, CRM, agenda, contabilidade fiscal, advocacia, imobiliária, fidelização, workflows, Google Workspace e IA — web e mobile na mesma plataforma.',
    badges: [
      { icon: 'ph-buildings', label: 'Matriz & Filiais' },
      { icon: 'ph-device-mobile', label: 'Web & Mobile' },
      { icon: 'ph-puzzle-piece', label: 'Complementos' },
    ],
    stats: [
      { icon: 'ph-squares-four', number: '16+', label: 'Módulos' },
      { icon: 'ph-globe', number: 'SaaS', label: 'Multiempresa' },
      { icon: 'ph-shield-check', number: 'LGPD', label: 'Auditoria' },
    ],
    demoText: 'Quero solicitar uma demonstração do Fontes Business One',
    categories: [
      { id: 'plataforma', name: 'Plataforma', icon: 'ph-package' },
      { id: 'documentos', name: 'Contratos', icon: 'ph-file-text' },
      { id: 'vendas', name: 'Vendas', icon: 'ph-chart-line-up' },
      { id: 'agenda', name: 'Agenda', icon: 'ph-calendar-check' },
      { id: 'segmentos', name: 'Segmentos', icon: 'ph-stack' },
      { id: 'automacao', name: 'Automação', icon: 'ph-flow-arrow' },
      { id: 'integracoes', name: 'Integrações', icon: 'ph-plugs-connected' },
      { id: 'ia', name: 'IA', icon: 'ph-sparkle' },
    ],
    modules: [
      {
        id: 1,
        category: 'plataforma',
        name: 'Insights / Dashboard',
        icon: 'ph-chart-pie-slice',
        badge: 'Core',
        shortDesc: 'Painel analítico da unidade com KPIs conforme os módulos ativos',
        fullDesc: 'Visão operacional por tenant com indicadores sincronizados pelos módulos contratados e permissões do usuário.',
        features: [
          'KPIs por unidade e matriz',
          'Indicadores conforme módulos ativos',
          'Sync via autenticação e assinatura',
          'Acesso controlado por permissões',
          'Menu Insights em matriz, filial e standalone',
        ],
      },
      {
        id: 2,
        category: 'plataforma',
        name: 'Matriz & Unidades',
        icon: 'ph-buildings',
        badge: 'Core',
        shortDesc: 'Rede multiempresa: matriz, filiais e empresa individual',
        fullDesc: 'Estruture franquias e redes com licença na matriz, operação nas filiais e isolamento multi-tenant por empresa.',
        features: [
          'Matriz (franchise_hq) e unidades',
          'Empresa individual (standalone)',
          'Troca/simulação de unidade',
          'Licença centralizada na matriz',
          'Isolamento por company_id',
          'Módulos herdados pelas filiais',
        ],
      },
      {
        id: 3,
        category: 'plataforma',
        name: 'Clientes',
        icon: 'ph-users-three',
        badge: 'Core',
        shortDesc: 'Cadastro unificado PF/PJ compartilhado entre os segmentos',
        fullDesc: 'Base única de clientes do escritório, reutilizada por Contabilidade, Advocacia, CRM e demais módulos.',
        features: [
          'CRUD de clientes PF/PJ',
          'Base compartilhada entre segmentos',
          'Isolamento por tenant',
          'Busca e vínculo com perfis dos módulos',
          'Núcleo do ERP (fora do marketplace)',
        ],
      },
      {
        id: 4,
        category: 'plataforma',
        name: 'Marketplace de Complementos',
        icon: 'ph-storefront',
        badge: 'Core',
        shortDesc: 'Ative complementos gratuitos ou solicite os pagos sob demanda',
        fullDesc: 'Catálogo de complementos com preço, categoria e status. Expanda o ERP sem trocar de sistema.',
        features: [
          'Catálogo com preço e categorias',
          'Ativação self-serve de apps grátis',
          'Solicitação de complementos pagos',
          'Governança pelo Super Admin',
          'Ativar, solicitar e desativar',
        ],
      },
      {
        id: 5,
        category: 'plataforma',
        name: 'Configurações',
        icon: 'ph-gear',
        badge: 'Core',
        shortDesc: 'Equipe, permissões, branding, licença e laboratório de API',
        fullDesc: 'Centro administrativo da empresa: usuários, ACL, identidade visual, licença e portal OpenAPI.',
        features: [
          'Perfil e colaboradores',
          'Funções e permissões (ACL/CASL)',
          'Identidade visual (white-label)',
          'Gestão de licença',
          'Laboratório API (OpenAPI filtrado)',
          'Serviços da empresa',
        ],
      },
      {
        id: 6,
        category: 'documentos',
        name: 'Contratos Digitais',
        icon: 'ph-file-text',
        badge: 'Core',
        shortDesc: 'Propostas e contratos com assinatura e validade jurídica',
        fullDesc: 'Construtor TipTap, templates, fluxo público de assinatura, OTP, hash SHA-256, TSA, ICP-Brasil e biometria facial opcional.',
        features: [
          'Editor TipTap com variáveis',
          'Templates reutilizáveis',
          'Assinatura pública (/c/{uuid})',
          'OTP por e-mail + CPF/CNPJ',
          'Hash SHA-256 + carimbo TSA',
          'Certificado ICP-Brasil A1',
          'Biometria facial opcional',
          'Código verificável FB1-XXXX + auditoria',
        ],
      },
      {
        id: 7,
        category: 'vendas',
        name: 'Negócios / CRM',
        icon: 'ph-funnel',
        badge: 'Complemento',
        shortDesc: 'Pipeline comercial com kanban, landing pages, equipes e automações',
        fullDesc: 'CRM completo multi-pipeline: leads, contatos, empresas, produtos, workflows, LP pública, formulários, e-mail e relatórios.',
        features: [
          'Multi-pipeline com colunas customizáveis',
          'Kanban e lista de leads',
          'Contatos, empresas e produtos',
          'Campos personalizados e tags',
          'Equipes com round-robin',
          'Workflows e templates de automação',
          'Landing page pública com UTM',
          'Formulários web, e-mails e ligações',
          'Import/export CSV e lixeira',
          'Relatórios de funil, fontes e timeline',
        ],
      },
      {
        id: 8,
        category: 'vendas',
        name: 'Fidelização por Indicação',
        icon: 'ph-handshake',
        badge: 'Complemento',
        shortDesc: 'Programa indique e ganhe com 2 níveis, carteira e resgates',
        fullDesc: 'Indicações diretas e indiretas, bônus, carteira auditável, resgates e central de aprovação — web e app.',
        features: [
          'Indicação direta e indireta (2 níveis)',
          'Bônus percentual ou valor fixo',
          'Carteira: disponível, bloqueado, resgatado',
          'Validade configurável do bônus',
          'Resgates PIX, transferência ou crédito',
          'Central de aprovação e pagamento',
          'Insights e ranking',
          'Ledger financeiro append-only',
        ],
      },
      {
        id: 9,
        category: 'agenda',
        name: 'Agenda & Booking',
        icon: 'ph-calendar-check',
        badge: 'Complemento',
        shortDesc: 'Agenda profissional com booking público, lembretes e integrações',
        fullDesc: 'Calendário estilo Calendly: serviços, salas, lista de espera, booking público, sync Google/Outlook, SMS, Stripe e webhooks.',
        features: [
          'Calendário dia/semana/mês com drag & drop',
          'Serviços, horários, salas e bloqueios',
          'Lista de espera e prevenção de conflitos',
          'Booking público multi-step com branding',
          'Round-robin de profissionais',
          'Recorrência e enquetes de reunião',
          'Sync Google/Outlook + SMS Twilio',
          'Pagamentos Stripe no booking',
          'Webhooks HMAC e portal do cliente',
          'Tipos: presencial, vídeo, domiciliar',
        ],
      },
      {
        id: 10,
        category: 'segmentos',
        name: 'Contabilidade Fiscal',
        icon: 'ph-calculator',
        badge: 'Complemento',
        shortDesc: 'Empresas fiscais, OCR, NF-e, obrigações e planejamento tributário',
        fullDesc: 'Operação contábil fiscal completa: CNAEs, regras, documentos OCR, caixa de XMLs, aprovações, NF-e, conciliação e relatórios.',
        features: [
          'Painel com KPIs fiscais',
          'Empresas fiscais e CNAEs (IBGE)',
          'Regras fiscais configuráveis',
          'Documentos com OCR',
          'Caixa de XMLs e aprovações',
          'NF-e e conciliação',
          'Obrigações acessórias',
          'Planejamento tributário e relatórios',
          'Portal do cliente final',
        ],
      },
      {
        id: 11,
        category: 'segmentos',
        name: 'Advocacia',
        icon: 'ph-scales',
        badge: 'Complemento',
        shortDesc: 'Processos CNJ, prazos, timesheet, honorários e documentos',
        fullDesc: 'Gestão jurídica completa: processos, agenda de prazos, kanban, horas, financeiro, rateio e modelos de peças.',
        features: [
          'Processos com CNJ, tribunal e área',
          'Agenda de prazos e audiências',
          'Kanban de fluxo processual',
          'Timesheet / controle de horas',
          'Financeiro de honorários',
          'Rateio entre sócios/equipe',
          'Documentos e modelos de peças',
          'Cadastros: varas, tribunais, classes',
        ],
      },
      {
        id: 12,
        category: 'segmentos',
        name: 'Imobiliária',
        icon: 'ph-house',
        badge: 'Complemento',
        shortDesc: 'Imóveis, locações, cobranças, corretores e portais',
        fullDesc: 'Operação imobiliária de ponta a ponta: cadastro, mídia, locações, inadimplência, comissões, vistorias, portais e API pública.',
        features: [
          'Imóveis venda/aluguel com mídia (R2)',
          'Proprietários, corretores e equipe',
          'Solicitações de compra e aluguel',
          'Locações, cobranças e inadimplência',
          'Comissões, reajustes e repasses',
          'Manutenções e vistorias (laudo)',
          'Portal do corretor e do cliente',
          'API pública / SEO e Google Maps',
          'Integração com Contratos e CRM',
        ],
      },
      {
        id: 13,
        category: 'automacao',
        name: 'Workflows',
        icon: 'ph-flow-arrow',
        badge: 'Complemento',
        shortDesc: 'Automações cross-módulo com gatilhos, condições e ações',
        fullDesc: 'Regras “quando X → então Y” integradas aos hooks da plataforma, com auditoria e ações em módulos contratados.',
        features: [
          'Gatilhos, condições e ações',
          'Webhook, e-mail e eventos',
          'Integração com CRM e plataforma',
          'Auditoria de execuções',
          'Só age em módulos contratados',
        ],
      },
      {
        id: 14,
        category: 'integracoes',
        name: 'Google Workspace',
        icon: 'ph-google-logo',
        badge: 'Complemento',
        shortDesc: 'Drive, Docs, Sheets, Slides e Forms dentro do sistema',
        fullDesc: 'OAuth por usuário com tokens criptografados, Sync Center, Activity Log e isolamento multi-tenant.',
        features: [
          'OAuth 2.0 por usuário',
          'Drive, Docs, Sheets, Slides e Forms',
          'Criar, listar, abrir e sincronizar',
          'Sync Center com retries',
          'Activity Log e config admin',
          'Isolamento multi-tenant',
        ],
      },
      {
        id: 15,
        category: 'integracoes',
        name: 'API & Laboratório',
        icon: 'ph-code',
        badge: 'Core',
        shortDesc: 'OpenAPI filtrado pelos módulos contratados',
        fullDesc: 'Portal do desenvolvedor com documentação OpenAPI (Scalar) limitada ao que a assinatura libera — API-first para web e mobile.',
        features: [
          'OpenAPI filtrado por assinatura',
          'Mesmas APIs para Vue e mobile',
          'JWT + contexto de tenant',
          'Webhooks e integrações externas',
        ],
      },
      {
        id: 16,
        category: 'ia',
        name: 'Assistente IA',
        icon: 'ph-sparkle',
        badge: 'Complemento',
        shortDesc: 'Personas internas estilo ChatGPT com a chave da empresa',
        fullDesc: 'Assistentes para a equipe interna, com histórico, múltiplos provedores e configuração em Settings.',
        features: [
          'Múltiplos assistentes/personas',
          'Histórico de conversas',
          'OpenAI, Gemini ou Claude',
          'Chave própria da empresa',
          'Uso interno da equipe',
        ],
      },
      {
        id: 17,
        category: 'ia',
        name: 'Chatbot Training',
        icon: 'ph-chats-circle',
        badge: 'Complemento',
        shortDesc: 'Treine bots com documentos e publique widget no site (RAG)',
        fullDesc: 'Fontes PDF, Word, áudio, YouTube e site; treino assíncrono; isolamento por empresa; widget com domínios autorizados.',
        features: [
          'Treino com PDF, Word, áudio e YouTube',
          'Motor RAG isolado por bot',
          'Widget embed no site',
          'Domínios autorizados',
          'Conversas públicas persistidas',
          'Permissões de treino e publicação',
        ],
      },
    ],
  },

  'erp-escolar': {
    slug: 'erp-escolar',
    name: 'ERP Escolar',
    shortName: 'Escola',
    badge: 'Gestão Escolar Completa • Web & Mobile',
    headline: 'ERP escolar completo para administrar',
    highlight: 'escolas e redes',
    description:
      'Plataforma completa para escolas e redes: acadêmico, pessoas, financeiro, biblioteca, comunicação, portais de pais, alunos e professores, e complementos como CRM, fidelização, loja, transporte, estoque, RH e IA — com web e app mobile.',
    badges: [
      { icon: 'ph-graduation-cap', label: 'Acadêmico' },
      { icon: 'ph-device-mobile', label: 'App Mobile' },
      { icon: 'ph-users', label: '3 Portais' },
    ],
    stats: [
      { icon: 'ph-student', number: '3', label: 'Portais' },
      { icon: 'ph-device-mobile', number: 'iOS/Android', label: 'App' },
      { icon: 'ph-buildings', number: 'Rede', label: 'Multunidade' },
    ],
    demoText: 'Quero solicitar uma demonstração do ERP Escolar',
    categories: [
      { id: 'rede', name: 'Rede', icon: 'ph-buildings' },
      { id: 'academico', name: 'Acadêmico', icon: 'ph-graduation-cap' },
      { id: 'pessoas', name: 'Pessoas', icon: 'ph-users-three' },
      { id: 'financeiro', name: 'Financeiro', icon: 'ph-currency-circle-dollar' },
      { id: 'comunicacao', name: 'Comunidade', icon: 'ph-megaphone' },
      { id: 'portais', name: 'Portais', icon: 'ph-browsers' },
      { id: 'complementos', name: 'Complementos', icon: 'ph-puzzle-piece' },
      { id: 'admin', name: 'Administração', icon: 'ph-gear' },
    ],
    modules: [
      {
        id: 1,
        category: 'rede',
        name: 'Dashboard',
        icon: 'ph-chart-pie-slice',
        badge: 'Core',
        shortDesc: 'Painel analítico da escola/unidade com visão operacional',
        fullDesc: 'Indicadores da unidade, atalhos do dia a dia e contexto por tenant (matriz ou unidade).',
        features: [
          'KPIs da unidade',
          'Atalhos operacionais',
          'Contexto matriz ou unidade',
          'Disponível na web e resumo no mobile',
        ],
      },
      {
        id: 2,
        category: 'rede',
        name: 'Matriz & Unidades',
        icon: 'ph-buildings',
        badge: 'Core',
        shortDesc: 'Rede multiunidade com isolamento de dados por escola',
        fullDesc: 'Matriz e unidades com troca de contexto por slug, módulos por assinatura e visão consolidada na matriz.',
        features: [
          'Matriz e unidades/franquias',
          'Troca de contexto por tenant',
          'CRUD de unidades pela matriz',
          'Isolamento multi-tenant',
          'Financeiro consolidado na matriz',
          'Módulos liberados por unidade',
        ],
      },
      {
        id: 3,
        category: 'academico',
        name: 'Estrutura Acadêmica',
        icon: 'ph-tree-structure',
        badge: 'Core',
        shortDesc: 'Ano letivo, turmas, seções, disciplinas, salas e departamentos',
        fullDesc: 'Base da operação escolar: sessões, turmas, assuntos, salas e departamentos para matrícula, horários e notas.',
        features: [
          'Anos letivos / sessões',
          'Turmas e seções',
          'Disciplinas',
          'Salas de aula',
          'Departamentos',
        ],
      },
      {
        id: 4,
        category: 'academico',
        name: 'Frequência',
        icon: 'ph-clipboard-text',
        badge: 'Core',
        shortDesc: 'Controle de presença diária por turma e aluno',
        fullDesc: 'Lançamento de presença no admin e no portal do professor, com acompanhamento nos portais da família e do aluno.',
        features: [
          'Chamada diária',
          'Portal do professor',
          'Consulta no portal do pai',
          'Consulta no portal do aluno',
        ],
      },
      {
        id: 5,
        category: 'academico',
        name: 'Horários & Syllabus',
        icon: 'ph-calendar',
        badge: 'Core',
        shortDesc: 'Grade de aulas, rotinas e programa de disciplinas',
        fullDesc: 'Organize a rotina escolar e disponibilize horários e syllabus nos portais.',
        features: [
          'Rotinas / grade de horários',
          'Programa / syllabus',
          'Visível para pai, aluno e professor',
        ],
      },
      {
        id: 6,
        category: 'academico',
        name: 'Avaliações & Boletim',
        icon: 'ph-exam',
        badge: 'Core',
        shortDesc: 'Provas, categorias, escalas, gradebook e impressão de boletim',
        fullDesc: 'Ciclo completo de avaliação: categorias, provas, notas, escalas e boletim impresso.',
        features: [
          'Categorias de exame',
          'Provas e marcações',
          'Livro de notas (gradebook)',
          'Escalas de nota',
          'Impressão de boletim',
          'Lançamento no portal do professor',
        ],
      },
      {
        id: 7,
        category: 'academico',
        name: 'Tarefas / Deveres',
        icon: 'ph-notebook',
        badge: 'Core',
        shortDesc: 'Deveres com prazo, anexos, entregas e notas',
        fullDesc: 'Assignments com submissions, anexos no portal do aluno e controle de prazos.',
        features: [
          'Lista de tarefas',
          'Entregas / submissions',
          'Anexos',
          'Prazos e notas',
          'Portal do aluno',
        ],
      },
      {
        id: 8,
        category: 'pessoas',
        name: 'Alunos & Matrículas',
        icon: 'ph-student',
        badge: 'Core',
        shortDesc: 'Cadastro, lista de espera, admissão, matrícula e promoção',
        fullDesc: 'Ciclo completo do aluno: diretório, espera pública, documentação, homologação, promoção e carteirinha.',
        features: [
          'Diretório de alunos',
          'Lista de espera',
          'Admissão familiar',
          'Matrículas e documentos',
          'Promoção de turmas/anos',
          'Carteirinha do aluno',
          'Operação no app mobile (staff)',
        ],
      },
      {
        id: 9,
        category: 'pessoas',
        name: 'Professores',
        icon: 'ph-chalkboard-teacher',
        badge: 'Core',
        shortDesc: 'Cadastro docente, permissões e vínculo com turmas',
        fullDesc: 'Gestão de professores com permissões específicas, portal dedicado e contracheques quando o RH estiver ativo.',
        features: [
          'Diretório de professores',
          'Permissões do professor',
          'Vínculo com turmas',
          'Portal do professor',
          'Contracheques (com RH)',
        ],
      },
      {
        id: 10,
        category: 'pessoas',
        name: 'Responsáveis',
        icon: 'ph-house',
        badge: 'Core',
        shortDesc: 'Pais/responsáveis e vínculos com alunos (guardiões)',
        fullDesc: 'Cadastro familiar com vínculos responsável↔aluno, base do portal da família e da comunicação.',
        features: [
          'Diretório de responsáveis',
          'Vínculos com alunos/irmãos',
          'Base do portal da família',
          'Integração com financeiro e avisos',
        ],
      },
      {
        id: 11,
        category: 'pessoas',
        name: 'Funcionários',
        icon: 'ph-identification-badge',
        badge: 'Core',
        shortDesc: 'Equipe administrativa e operacional da unidade',
        fullDesc: 'Diretório de staff separado de professores e do RH avançado, com apoio a permissões e operação.',
        features: [
          'Diretório de funcionários',
          'Separação de papéis',
          'Apoio a permissões',
        ],
      },
      {
        id: 12,
        category: 'financeiro',
        name: 'Mensalidades',
        icon: 'ph-receipt',
        badge: 'Core',
        shortDesc: 'Tabela de preços, acordos, receitas, offline e inadimplência',
        fullDesc: 'Cobrança escolar por turno/ano, recorrência, pagamentos offline com review, inadimplência e informes de rendimento.',
        features: [
          'Preços por turno (manhã/tarde/integral)',
          'Acordos e recorrência automática',
          'Receitas / faturas',
          'Pagamentos offline + fila de review',
          'Inadimplência',
          'Informes de rendimento',
          'Consulta no portal do responsável',
        ],
      },
      {
        id: 13,
        category: 'financeiro',
        name: 'Despesas',
        icon: 'ph-wallet',
        badge: 'Core',
        shortDesc: 'Contas a pagar, categorias e comprovantes',
        fullDesc: 'Despesas com status, baixa no fluxo de caixa e perfil dedicado para contador.',
        features: [
          'Despesas com categorias',
          'Status pendente/pago/vencido',
          'Baixa alimenta o caixa',
          'Comprovantes anexáveis',
          'Perfil contador',
        ],
      },
      {
        id: 14,
        category: 'financeiro',
        name: 'Financeiro Avançado',
        icon: 'ph-bank',
        badge: 'Core',
        shortDesc: 'Fluxo de caixa, fechamento, bancos e centros de custo',
        fullDesc: 'Caixa previsto × recebido × pago, competência vs pagamento, matrícula percentual por turno, fechamento mensal e consolidado da matriz.',
        features: [
          'Dashboard financeiro completo',
          'Matrícula = % da mensalidade por turno',
          'Competência vs data de pagamento',
          'Fechamento mensal',
          'Contas bancárias',
          'Centros de custo',
          'Painel consolidado na matriz',
          'Multa, juros e descontos',
        ],
      },
      {
        id: 15,
        category: 'comunicacao',
        name: 'Avisos & Eventos',
        icon: 'ph-megaphone',
        badge: 'Core',
        shortDesc: 'Mural de comunicados e calendário de eventos',
        fullDesc: 'Comunicação escolar centralizada para admin, professores, pais e alunos.',
        features: [
          'Mural de avisos',
          'Eventos da escola',
          'Visível nos 3 portais',
          'Mensagens internas',
        ],
      },
      {
        id: 16,
        category: 'comunicacao',
        name: 'Biblioteca',
        icon: 'ph-book-open',
        badge: 'Core',
        shortDesc: 'Acervo, empréstimos e perfil do bibliotecário',
        fullDesc: 'Gestão completa da biblioteca com portal do aluno e painel do bibliotecário.',
        features: [
          'Cadastro de livros',
          'Empréstimos',
          'Portal do aluno',
          'Perfil bibliotecário',
        ],
      },
      {
        id: 17,
        category: 'comunicacao',
        name: 'Clubes',
        icon: 'ph-users-three',
        badge: 'Core',
        shortDesc: 'Atividades extracurriculares com membros e portais',
        fullDesc: 'Gestão de clubes com painéis para admin, professor e aluno.',
        features: [
          'Cadastro de clubes',
          'Gestão de membros',
          'Portal professor e aluno',
        ],
      },
      {
        id: 18,
        category: 'comunicacao',
        name: 'Feedback Pedagógico',
        icon: 'ph-chat-circle-text',
        badge: 'Core',
        shortDesc: 'Feedbacks e avaliações pedagógicas',
        fullDesc: 'Canal de feedback e appraisals pedagógicos com menu dedicado na unidade.',
        features: [
          'Feedbacks',
          'Avaliações pedagógicas',
          'Menu dedicado',
        ],
      },
      {
        id: 19,
        category: 'portais',
        name: 'Portal do Responsável',
        icon: 'ph-house-line',
        badge: 'Portal',
        shortDesc: 'Filhos, financeiro, notas, frequência, avisos e loja',
        fullDesc: 'Área completa da família: filhos, mensalidades, histórico, informe de rendimentos, frequência, notas, horários, eventos e loja.',
        features: [
          'Meus filhos',
          'Mensalidades e histórico',
          'Informe de rendimentos',
          'Frequência, notas e horários',
          'Avisos e eventos',
          'Loja e pedidos (com complemento)',
        ],
      },
      {
        id: 20,
        category: 'portais',
        name: 'Portal do Aluno',
        icon: 'ph-student',
        badge: 'Portal',
        shortDesc: 'Matrícula, notas, tarefas, clubes, biblioteca e avisos',
        fullDesc: 'Espaço do aluno com vida acadêmica completa e app mobile.',
        features: [
          'Matrícula e mensalidades',
          'Frequência e notas',
          'Horários e disciplinas',
          'Tarefas e entregas',
          'Clubes e biblioteca',
          'App mobile',
        ],
      },
      {
        id: 21,
        category: 'portais',
        name: 'Portal do Professor',
        icon: 'ph-chalkboard',
        badge: 'Portal',
        shortDesc: 'Turmas, chamada, notas, provas, horários e contracheques',
        fullDesc: 'Ferramentas do dia a dia docente em um único portal.',
        features: [
          'Turmas e alunos',
          'Frequência e notas',
          'Provas',
          'Horários e syllabus',
          'Avisos e clubes',
          'Contracheques (RH)',
        ],
      },
      {
        id: 22,
        category: 'complementos',
        name: 'CRM de Matrículas',
        icon: 'ph-funnel',
        badge: 'Complemento',
        shortDesc: 'Funil de captação com kanban, leads, LP e workflows',
        fullDesc: 'CRM comercial para matrículas: pipelines, equipes, landing pages públicas, tags e relatórios.',
        features: [
          'Pipeline kanban multi-funil',
          'Leads e timeline',
          'Equipes com round-robin',
          'Workflows automatizados',
          'Landing page pública',
          'Relatórios de funil e fontes',
        ],
      },
      {
        id: 23,
        category: 'complementos',
        name: 'Fidelização',
        icon: 'ph-handshake',
        badge: 'Complemento',
        shortDesc: 'Indique e ganhe com 2 níveis, carteira e resgates',
        fullDesc: 'Programa de indicação para pais/alunos com carteira, aprovação e app.',
        features: [
          'Indicações em 2 níveis',
          'Bônus % ou fixo',
          'Carteira e resgates',
          'Insights e financeiro',
          'Web e mobile',
        ],
      },
      {
        id: 24,
        category: 'complementos',
        name: 'Loja Virtual',
        icon: 'ph-storefront',
        badge: 'Complemento',
        shortDesc: 'Vitrine para responsáveis com pedidos via WhatsApp',
        fullDesc: 'Catálogo de produtos, pedidos e vitrine no portal dos pais — ideal para uniformes e materiais.',
        features: [
          'Catálogo e categorias',
          'Pedidos',
          'Vitrine no portal do pai',
          'Pedidos via WhatsApp',
        ],
      },
      {
        id: 25,
        category: 'complementos',
        name: 'Transporte Escolar',
        icon: 'ph-bus',
        badge: 'Complemento',
        shortDesc: 'Motoristas, veículos e alocações/rotas',
        fullDesc: 'Gestão da frota escolar com motoristas, veículos e alocações.',
        features: [
          'Motoristas',
          'Veículos',
          'Alocações / rotas',
          'Check-in (catálogo)',
        ],
      },
      {
        id: 26,
        category: 'complementos',
        name: 'Estoque',
        icon: 'ph-package',
        badge: 'Complemento',
        shortDesc: 'Materiais e patrimônio com movimentações',
        fullDesc: 'Inventário escolar com categorias, itens, entradas/baixas e relatório.',
        features: [
          'Categorias e itens',
          'Movimentações',
          'Relatório compra/venda',
          'Alertas',
        ],
      },
      {
        id: 27,
        category: 'complementos',
        name: 'RH Escolar',
        icon: 'ph-identification-card',
        badge: 'Complemento',
        shortDesc: 'Funcionários, folha, ponto, afastamentos e contracheques',
        fullDesc: 'RH completo com rubricas, payrolls, ponto e portal de contracheques.',
        features: [
          'Funcionários RH',
          'Rubricas e folha',
          'Ponto e afastamentos',
          'Portal de contracheques',
        ],
      },
      {
        id: 28,
        category: 'complementos',
        name: 'Cursos Online',
        icon: 'ph-monitor-play',
        badge: 'Complemento',
        shortDesc: 'Cursos, aulas em vídeo e matrículas em trilhas',
        fullDesc: 'Conteúdo digital para a escola com cursos, aulas e matrículas.',
        features: [
          'Cursos e aulas',
          'Matrículas',
          'Trilhas / certificados',
        ],
      },
      {
        id: 29,
        category: 'complementos',
        name: 'Central SMS',
        icon: 'ph-chat-text',
        badge: 'Complemento',
        shortDesc: 'Comunicados por SMS para responsáveis',
        fullDesc: 'Envio em massa ou por turma com templates e histórico.',
        features: [
          'Envio por audiência',
          'Templates',
          'Histórico',
          'Configurações',
        ],
      },
      {
        id: 30,
        category: 'complementos',
        name: 'Alumni',
        icon: 'ph-graduation-cap',
        badge: 'Complemento',
        shortDesc: 'Rede de ex-alunos, eventos e galeria',
        fullDesc: 'Engajamento de egressos com cadastro, eventos e galeria.',
        features: [
          'Cadastro de ex-alunos',
          'Eventos alumni',
          'Galeria',
        ],
      },
      {
        id: 31,
        category: 'complementos',
        name: 'Assistente IA',
        icon: 'ph-sparkle',
        badge: 'Complemento',
        shortDesc: 'Personas internas com a chave da própria escola',
        fullDesc: 'Assistentes ChatGPT-like para a equipe, com histórico e múltiplos provedores.',
        features: [
          'Múltiplos assistentes',
          'Histórico de chats',
          'Chave própria (OpenAI/Gemini/Claude)',
        ],
      },
      {
        id: 32,
        category: 'complementos',
        name: 'Chatbot Training',
        icon: 'ph-chats-circle',
        badge: 'Complemento',
        shortDesc: 'Bot treinável com documentos e widget no site da escola',
        fullDesc: 'Treino RAG com PDF/Word/áudio/YouTube e publicação embedável no site.',
        features: [
          'Treino com documentos e mídia',
          'RAG multi-tenant',
          'Widget no site',
          'Domínios autorizados',
        ],
      },
      {
        id: 33,
        category: 'admin',
        name: 'Permissões & Colaboradores',
        icon: 'ph-lock-key',
        badge: 'Core',
        shortDesc: 'RBAC por unidade com funções, toggles e enforcement na API',
        fullDesc: 'Controle fino de acesso com CASL, colaboradores e bloqueio de módulos não contratados.',
        features: [
          'Funções e permissões',
          'Colaboradores da unidade',
          'Enforcement na API',
          'Perfis: contador, bibliotecário, secretária',
        ],
      },
      {
        id: 34,
        category: 'admin',
        name: 'Identidade Visual',
        icon: 'ph-palette',
        badge: 'Core',
        shortDesc: 'Logo, cores e tema por escola/tenant',
        fullDesc: 'White-label por unidade com logo, favicon, cor primária e tema dinâmico.',
        features: [
          'Logo e favicon',
          'Cor primária e tema',
          'Aplicação dinâmica no layout',
        ],
      },
      {
        id: 35,
        category: 'admin',
        name: 'Configurações da Escola',
        icon: 'ph-sliders',
        badge: 'Core',
        shortDesc: 'SMTP, FAQ, documentos de matrícula e preferências',
        fullDesc: 'Central de configurações operacionais da unidade e onboarding in-app.',
        features: [
          'Escola / SMTP / site',
          'FAQ',
          'Tipos de documentos de matrícula',
          'Métodos de pagamento',
          'Tutorial in-app',
        ],
      },
    ],
  },

  nutraxis: {
    slug: 'nutraxis',
    name: 'Nutraxis',
    shortName: 'Nutricionistas',
    badge: 'Sistema Completo para Nutricionistas',
    headline: 'Plataforma completa para',
    highlight: 'nutricionistas e clínicas',
    description:
      'O Nutraxis é o sistema completo para nutricionistas autônomos, clínicas e franquias: prontuário, planos alimentares, agenda, CRM, IA, fidelização e portal do paciente — tudo modular e multiempresa.',
    badges: [
      { icon: 'ph-heartbeat', label: 'Prontuário' },
      { icon: 'ph-fork-knife', label: 'Planos' },
      { icon: 'ph-buildings', label: 'Clínicas & Franquias' },
    ],
    stats: [
      { icon: 'ph-user-circle', number: '3', label: 'Perfis' },
      { icon: 'ph-puzzle-piece', number: 'Modular', label: 'Complementos' },
      { icon: 'ph-shield-check', number: 'LGPD', label: 'Compliance' },
    ],
    demoText: 'Quero solicitar uma demonstração do Nutraxis',
    categories: [
      { id: 'clinico', name: 'Clínico', icon: 'ph-heartbeat' },
      { id: 'agenda', name: 'Agenda', icon: 'ph-calendar-check' },
      { id: 'gestao', name: 'Gestão', icon: 'ph-buildings' },
      { id: 'crescimento', name: 'Crescimento', icon: 'ph-chart-line-up' },
      { id: 'ia', name: 'IA', icon: 'ph-sparkle' },
    ],
    modules: [
      {
        id: 1,
        category: 'clinico',
        name: 'Pacientes & Prontuário',
        icon: 'ph-user-circle',
        badge: 'Core',
        shortDesc: 'Cadastro, anamnese, IMC, avaliações e histórico',
        fullDesc: 'Prontuário clínico completo com anamnese, medições, avaliações e registros de saúde.',
        features: ['Cadastro completo', 'Anamnese', 'IMC', 'Avaliações', 'Histórico clínico'],
      },
      {
        id: 2,
        category: 'clinico',
        name: 'Plano Alimentar',
        icon: 'ph-fork-knife',
        badge: 'Core',
        shortDesc: 'Planos semanais com refeições, itens e orientações',
        fullDesc: 'Monte planos de seg a dom com refeições, itens, orientação e período de vigência.',
        features: ['Plano semanal', 'Refeições e itens', 'Orientações', 'Vigência'],
      },
      {
        id: 3,
        category: 'clinico',
        name: 'Diário Alimentar',
        icon: 'ph-notebook',
        badge: 'Core',
        shortDesc: 'Acompanhamento diário de refeições e hidratação',
        fullDesc: 'Registro das refeições do dia, horários, água e anotações do paciente.',
        features: ['Refeições do dia', 'Ingestão de água', 'Anotações', 'Acompanhamento'],
      },
      {
        id: 4,
        category: 'clinico',
        name: 'Questionários',
        icon: 'ph-list-checks',
        badge: 'Core',
        shortDesc: 'Atribuição e acompanhamento de questionários',
        fullDesc: 'Envie e acompanhe questionários clínicos vinculados ao paciente.',
        features: ['Atribuição', 'Acompanhamento', 'Histórico'],
      },
      {
        id: 5,
        category: 'agenda',
        name: 'Agenda Inteligente',
        icon: 'ph-calendar-check',
        badge: 'Core',
        shortDesc: 'Calendário, salas, lista de espera e prevenção de conflitos',
        fullDesc: 'Agenda profissional com drag & drop, salas, disponibilidade, bloqueios e remarcações.',
        features: ['Mês/semana/dia', 'Salas', 'Lista de espera', 'Conflitos automáticos', 'Lembretes WhatsApp'],
      },
      {
        id: 6,
        category: 'agenda',
        name: 'Serviços & Catálogo',
        icon: 'ph-tag',
        badge: 'Core',
        shortDesc: 'Catálogo de serviços com preço e imagem',
        fullDesc: 'Base de serviços da clínica para agenda, indicações e comercial.',
        features: ['Preço', 'Imagem', 'Status ativo', 'Base para agenda'],
      },
      {
        id: 7,
        category: 'gestao',
        name: 'Clínicas & Franquias',
        icon: 'ph-buildings',
        badge: 'Core',
        shortDesc: 'Matriz, filiais e clínicas independentes',
        fullDesc: 'Escale do consultório individual à rede de franquias com isolamento multi-tenant.',
        features: ['Matriz e filiais', 'Troca de unidade', 'Branding', 'Colaboradores'],
      },
      {
        id: 8,
        category: 'gestao',
        name: 'Portal do Paciente',
        icon: 'ph-device-mobile',
        badge: 'Core',
        shortDesc: 'Área do paciente com jornada, questionários e perfil',
        fullDesc: 'Portal web do paciente com vínculos, jornada e acompanhamento.',
        features: ['Dashboard', 'Minha jornada', 'Questionários', 'Perfil'],
      },
      {
        id: 9,
        category: 'gestao',
        name: 'Financeiro',
        icon: 'ph-wallet',
        badge: 'Core',
        shortDesc: 'Fluxo de caixa, recebíveis, split e conciliação',
        fullDesc: 'Financeiro avançado para a clínica acompanhar recebimentos e conciliação.',
        features: ['Fluxo de caixa', 'Recebíveis', 'Split', 'Conciliação'],
      },
      {
        id: 10,
        category: 'crescimento',
        name: 'CRM & Atendimento',
        icon: 'ph-funnel',
        badge: 'Complemento',
        shortDesc: 'Pipeline, leads, landing pages e conversão em paciente',
        fullDesc: 'Capte leads e converta em pacientes com kanban, workflows e landing pages.',
        features: ['Pipeline', 'Landing pages', 'Workflows', 'Lead → paciente'],
      },
      {
        id: 11,
        category: 'crescimento',
        name: 'Fidelização',
        icon: 'ph-handshake',
        badge: 'Complemento',
        shortDesc: 'Indicação em níveis com carteira e resgates',
        fullDesc: 'Programa de indicação com 2 níveis, carteira de bônus e resgates.',
        features: ['2 níveis', 'Carteira', 'Resgates', 'Insights'],
      },
      {
        id: 12,
        category: 'ia',
        name: 'NutriAI',
        icon: 'ph-sparkle',
        badge: 'IA',
        shortDesc: 'Assistentes internos para o dia a dia da clínica',
        fullDesc: 'Personas estilo ChatGPT com histórico e chave própria da clínica.',
        features: ['Personas', 'Histórico', 'Chave própria'],
      },
      {
        id: 13,
        category: 'ia',
        name: 'Receitas & Cardápios IA',
        icon: 'ph-cooking-pot',
        badge: 'IA',
        shortDesc: 'Geração de cardápios alinhados ao plano alimentar',
        fullDesc: 'Gere receitas e cardápios com IA alinhados ao plano do paciente.',
        features: ['Cardápios', 'Receitas', 'Alinhamento ao plano'],
      },
      {
        id: 14,
        category: 'ia',
        name: 'Chatbot Training',
        icon: 'ph-chats-circle',
        badge: 'IA',
        shortDesc: 'Chatbot treinável com documentos para o site da clínica',
        fullDesc: 'Treine com PDF, Word, áudio e YouTube e publique um widget no site.',
        features: ['Treino com docs', 'RAG', 'Widget embed'],
      },
    ],
  },
}

export function getProduct(slug) {
  return products[slug] || null
}
